import { c as _c } from "react/compiler-runtime";
import { gql, useQuery } from '@material-bank/graphql-client';
import type { Tag } from '@material-bank/mtag-graphql-schema';
import { PRODUCT_FIELDS, type ProductByVariantSkusResult } from './useProductByVariantSkusQuery';
type TagQueryData = {
  tag: Pick<Tag, 'id' | 'tagRef' | 'brandId' | 'brandRef' | 'brandConfig' | 'productRef' | 'replacementType' | 'replacementRef' | 'createdAt' | 'updatedAt' | 'projectRef'> & {
    // Resolved server-side from the tag's productRef, so tag + product arrive in
    // one round-trip instead of the client fetching the tag, reading productRef,
    // then fetching the product.
    product: ProductByVariantSkusResult | null;
  };
};

// Exported so the server render can execute the exact same document against the
// in-process BFF. Sharing the document (rather than re-declaring the selection)
// is what guarantees the server-resolved payload matches what the browser would
// have fetched for itself.
export const TAG_QUERY = gql`
  query TagQuery($tagRef: String!, $locale: String) {
    tag(tagRef: $tagRef) {
      id
      tagRef
      brandId
      brandRef
      brandConfig {
        contactRecipients {
          mode
          email
          phoneNumber
        }
        contactOptions {
          leadTime
          pricing
          other
          text
          call
        }
        productRetirement {
          mode
        }
        redirectUrl
      }
      productRef
      replacementType
      replacementRef
      createdAt
      updatedAt
      projectRef
      product(locale: $locale) {
        ...ProductFields
      }
    }
  }
  ${PRODUCT_FIELDS}
`;
export type TagQueryVars = {
  tagRef: string;
  locale?: string;
};
export type TagQueryTag = TagQueryData['tag'];
export function useTagQuery(options) {
  const $ = _c(4);
  const {
    data,
    error,
    loading
  } = useQuery(TAG_QUERY, options);
  const t0 = data?.tag;
  let t1;
  if ($[0] !== error || $[1] !== loading || $[2] !== t0) {
    t1 = {
      data: t0,
      error,
      loading
    };
    $[0] = error;
    $[1] = loading;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}